export const BASIC_PAGE_SIZES = [
  { key: '5', value: 5 },
  { key: '10', value: 10 },
  { key: '15', value: 15 },
  { key: '20', value: 20 },
];

export const TABLE_PAGE_SIZES = [
  { key: '10', value: 10 },
  { key: '20', value: 20 },
  { key: '50', value: 50 },
  { key: '100', value: 100 },
  { key: '500', value: 500 },
  { key: '1000', value: 1000 },
];
